export const DATABASE_CONFIG = {
  INITIALIZATION_TIMEOUT_MS: 120_000,
  MAX_SQL_LOG_LENGTH: 1000,
  NAME_PREFIX: "mem-client-db",
  DATABASE_VERSION: "v9",

  // Creation phase policies
  CREATE_TIMEOUT_MS: 5_000,
  CREATE_MAX_RETRIES: 5,
  CREATE_RETRY_MIN_MS: 300,
  CREATE_RETRY_MAX_MS: 2_000,
  CREATE_RETRY_FACTOR: 1.8,
  CREATE_RETRY_RANDOMIZE: true as const,

  // Migration phase policies
  MIGRATION_TIMEOUT_MS: 30_000,
  MIGRATION_MAX_RETRIES: 2,
  MIGRATION_RETRY_MIN_MS: 1_000,
  MIGRATION_RETRY_MAX_MS: 5_000,
  MIGRATION_RETRY_FACTOR: 1.8,
  MIGRATION_RETRY_RANDOMIZE: true as const,
};
